import './index.css';

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TOAST_TYPE_STYLES, TOAST_TYPES } from '../../constant/toast';
import { useSettingsStore } from '../../store/settings';

const ToastItem = ({ item, hideToast }) => {
  const { id, lines, duration, type, style } = item;

  useEffect(() => {
    const timer = setTimeout(() => {
      hideToast(id);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, hideToast, id]);

  const toastType = TOAST_TYPE_STYLES[type] ? type : TOAST_TYPES.WARNING;

  return (
    <div
      className={`toast-message toast-message--${toastType} toast-enter`}
      style={{ ...TOAST_TYPE_STYLES[toastType], ...style }}
      onClick={() => hideToast(id)}
      role="button"
      tabIndex={0}
      onKeyDown={event => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          hideToast(id);
        }
      }}
    >
      {lines.map((line, index) => (
        <div
          key={`${id}-${index}`}
          className={index === 0 ? 'toast-title' : 'toast-line'}
        >
          {line}
        </div>
      ))}
    </div>
  );
};

ToastItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    lines: PropTypes.arrayOf(PropTypes.string).isRequired,
    duration: PropTypes.number.isRequired,
    type: PropTypes.oneOf(Object.values(TOAST_TYPES)).isRequired,
    style: PropTypes.object
  }).isRequired,
  hideToast: PropTypes.func.isRequired
};

const Toast = () => {
  const toasts = useSettingsStore(state => state.toasts);
  const hideToast = useSettingsStore(state => state.hideToast);

  if (!toasts.length) {
    return null;
  }

  return (
    <div className="toast-container">
      <div className="toast-stack">
        {toasts.map(item => (
          <ToastItem key={item.id} item={item} hideToast={hideToast} />
        ))}
      </div>
    </div>
  );
};

export default Toast;
